module.exports = __webpack_public_path__ + "img/file.b5bb3f37.svg";